export const categories = [
  {
    slug: 'acting-career',
    name: '演艺经历',
    description: '孟若羽从入行至今的完整演艺生涯回顾',
    icon: 'ri-movie-line',
  },
  {
    slug: 'works',
    name: '作品集',
    description: '孟若羽参演的所有影视作品与综艺节目',
    icon: 'ri-film-line',
  },
  {
    slug: 'gallery',
    name: '写真图集',
    description: '孟若羽高清写真、活动照片与幕后花絮',
    icon: 'ri-camera-line',
  },
  {
    slug: 'news',
    name: '最新动态',
    description: '孟若羽最新行程、活动资讯与媒体报道',
    icon: 'ri-newspaper-line',
  },
  {
    slug: 'interviews',
    name: '访谈记录',
    description: '孟若羽接受媒体采访与深度对谈内容',
    icon: 'ri-mic-line',
  },
];

export interface Article {
  slug: string;
  title: string;
  category: string;
  categoryName: string;
  excerpt: string;
  content: string;
  imageUrl: string;
  date: string;
  readTime: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    slug: 'meng-ruoyu-2025-year-review',
    title: '孟若羽2025年度回顾：从新人到实力派演员的蜕变之路',
    category: 'acting-career',
    categoryName: '演艺经历',
    excerpt: '回顾2025年，孟若羽用一部部作品证明了自己的实力。从年初的热播剧到年底的电影首秀，她完成了一次华丽的蜕变。',
    content: `<p>2025年对于孟若羽来说，是意义非凡的一年。这一年，她完成了从新人演员到实力派艺人的蜕变，用作品和实力说话，赢得了观众和业内人士的一致认可。</p>
<h2>年初：《春风十里》热播，一战成名</h2>
<p>2025年1月，由孟若羽主演的都市情感剧《春风十里》在各大平台热播。她在剧中饰演的"林小满"一角深入人心，将一个勇敢追梦的都市女孩演绎得淋漓尽致。该剧播出期间全网热度突破30亿，孟若羽个人社交平台涨粉超过500万。</p>
<p>"这个角色让我第一次感受到被这么多人认识和喜欢的滋味，"孟若羽在后来的一次采访中回忆道，"那段时间每天都能收到很多粉丝的私信，有人说在'林小满'身上看到了自己的影子，这让我觉得做演员这件事真的很有意义。"</p>
<h2>年中：挑战舞台剧，突破自我</h2>
<p>2025年6月，孟若羽做出了一个令许多人意外的决定——参演大型舞台剧《繁花》，挑战完全不同的表演形式。连续三个月的高强度排练，每天从早上九点到晚上十点，她用汗水和坚持换来了舞台上的完美呈现。</p>
<p>《繁花》在北京、上海、广州三地巡演，场场爆满。剧评人称赞她"在舞台上有着超越年龄的沉稳与表现力"。这次舞台剧经历也让孟若羽的演技有了质的飞跃。</p>
<h2>年末：电影首秀，惊艳大银幕</h2>
<p>2025年11月，孟若羽的首部电影作品《城市之光》上映。这部现实题材的文艺片让她在大银幕上展现了完全不同于电视剧的表演质感。影片最终斩获2.8亿票房，对于一部文艺片来说成绩相当亮眼。</p>
<p>凭借《城市之光》中的出色表现，孟若羽获得了第38届华语电影传媒大奖最佳新演员提名，这也是她职业生涯的第一个重要奖项提名。</p>
<h2>展望2026</h2>
<p>对于已经到来的2026年，孟若羽表示会继续挑战更多不同类型的角色。"我不想被定义，也不希望观众给我贴上标签。演员最幸福的事情就是能够体验不同的人生，我希望每一个角色都是独一无二的。"</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20actress%20in%20warm%20studio%20lighting%2C%20soft%20portrait%20photography%20with%20cream%20background%2C%20artistic%20composition%2C%20minimal%20aesthetic%2C%20editorial%20fashion%20photography%20style%20with%20natural%20makeup%20and%20flowing%20hair&width=800&height=500&seq=article-2025-review&orientation=landscape',
    date: '2026-01-15',
    readTime: '8分钟',
    tags: ['年度回顾', '演艺经历', '春风十里', '城市之光'],
  },
  {
    slug: 'meng-ruoyu-new-drama-announcement',
    title: '重磅官宣！孟若羽确认出演古装大剧《长安赋》女一号',
    category: 'news',
    categoryName: '最新动态',
    excerpt: '孟若羽将搭档实力派演员出演大型古装剧《长安赋》，饰演一位在乱世中坚守信念的传奇女性，预计2026年3月开机。',
    content: `<p>据可靠消息，孟若羽已确认出演大型古装剧《长安赋》女一号，这将是她在2026年的首部重磅作品。该剧改编自同名畅销小说，讲述了唐朝盛世背景下一位传奇女性的成长故事。</p>
<h2>角色设定：传奇女性的史诗故事</h2>
<p>孟若羽将在剧中饰演女主角"沈清辞"，一位出身书香门第却命运多舛的女子。故事横跨三十年，展现了沈清辞从天真少女成长为运筹帷幄的家主，在乱世中守护家族与信念的传奇人生。</p>
<p>"沈清辞这个角色非常复杂，她身上有传统女性的温婉，也有现代女性的坚韧与独立。这种矛盾感和层次感正是吸引我接下这个角色的原因。"孟若羽在官宣文案中写道。</p>
<h2>制作团队：黄金班底打造年度巨制</h2>
<p>《长安赋》由曾执导《琅琊榜之风起长林》的知名导演执导，编剧团队耗时两年打磨剧本。美术指导邀请了曾参与《妖猫传》的顶级团队，力求还原盛唐气象。</p>
<p>据悉，该剧总投资超过3亿元，将在横店和敦煌两地取景拍摄，计划拍摄周期为6个月。预计2026年3月正式开机。</p>
<h2>粉丝期待值拉满</h2>
<p>消息一出，立刻引发粉丝热议。话题"孟若羽长安赋"迅速登上热搜榜，相关话题阅读量在24小时内突破5亿。粉丝纷纷表示："终于等到若羽的古装剧了！""期待若羽版的沈清辞！"</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20actress%20in%20traditional%20hanfu%20costume%2C%20soft%20dramatic%20lighting%2C%20ancient%20Chinese%20palace%20aesthetic%2C%20warm%20golden%20tones%2C%20cinematic%20portrait%20photography%20with%20flowing%20silk%20fabric%20and%20classical%20beauty&width=800&height=500&seq=article-new-drama&orientation=landscape',
    date: '2026-02-20',
    readTime: '6分钟',
    tags: ['古装剧', '长安赋', '官宣', '最新动态'],
  },
  {
    slug: 'meng-ruoyu-charity-event',
    title: '孟若羽现身"星光助学"公益活动，温暖助力山区儿童教育',
    category: 'news',
    categoryName: '最新动态',
    excerpt: '孟若羽作为公益大使出席"星光助学"年度慈善晚宴，现场捐赠并呼吁关注山区儿童教育问题，展现明星的社会担当。',
    content: `<p>近日，孟若羽作为公益大使出席了"星光助学"年度慈善晚宴，用实际行动支持山区儿童教育事业。活动现场，她以优雅大方的形象亮相，更以真挚的发言打动了在场所有人。</p>
<h2>公益初心：让每个孩子都能读书</h2>
<p>"我出生在一个普通的家庭，小时候父母为了让我接受好的教育付出了很多。所以我深知教育对一个人有多重要，"孟若羽在发言中说道，"当我了解到还有那么多山区的孩子因为经济条件而无法完成学业时，我觉得我必须做点什么。"</p>
<p>孟若羽不仅自己捐出了100万元用于建设三所希望小学的图书馆，还积极呼吁更多人关注山区儿童教育问题。她的真诚发言引发了现场的踊跃捐助，晚会最终募集善款超过2000万元。</p>
<h2>低调公益，用心陪伴</h2>
<p>据工作人员透露，这已经不是孟若羽第一次参与公益事业。早在2024年，她就默默资助了10名贫困学生完成学业，但从未对外公开。这次之所以愿意担任"星光助学"的公益大使，是希望借助自己的影响力让更多人关注到这个群体。</p>
<p>"明星的影响力是一把双刃剑，我想把它用在有意义的地方。"</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20actress%20at%20charity%20event%2C%20warm%20soft%20lighting%2C%20cream%20and%20gold%20decor%2C%20sincere%20expression%2C%20philanthropic%20atmosphere%2C%20editorial%20photography%20style%20with%20gentle%20smile%20and%20elegant%20dress&width=800&height=500&seq=article-charity&orientation=landscape',
    date: '2026-03-05',
    readTime: '5分钟',
    tags: ['公益活动', '星光助学', '社会责任', '最新动态'],
  },
  {
    slug: 'meng-ruoyu-award-nomination',
    title: '喜讯！孟若羽入围金鹰奖最佳女主角提名',
    category: 'news',
    categoryName: '最新动态',
    excerpt: '凭借在《春风十里》中的出色表现，孟若羽成功入围第32届中国电视金鹰奖最佳女主角提名，成为本届最年轻的入围者之一。',
    content: `<p>第32届中国电视金鹰奖提名名单今日正式公布，孟若羽凭借《春风十里》中"林小满"一角成功入围最佳女主角提名。这也是孟若羽出道以来获得的第一个主流电视剧奖项提名。</p>
<h2>从新人到提名：用实力证明自己</h2>
<p>孟若羽的入围让不少人感到惊喜。作为出道仅两年的新人演员，能够在金鹰奖这样重量级的奖项中崭露头角，充分证明了她的演技实力和观众的认可度。</p>
<p>"以前我觉得奖项离自己很远，"孟若羽在获知提名后接受采访时说，"但现在我更想把这份认可当作一种鼓励，激励我在未来的演艺道路上更加努力。"</p>
<h2>竞争激烈，心态平和</h2>
<p>本届金鹰奖最佳女主角的竞争异常激烈，与孟若羽同台竞争的都是有着丰富经验的实力派演员。对此，孟若羽表现得十分淡然："能和他们一起被提名已经是很大的荣幸了。结果不重要，重要的是继续演好每一个角色。"</p>
<p>颁奖典礼将于2026年10月在长沙举行，届时将揭晓最终获奖名单。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20actress%20at%20award%20ceremony%2C%20warm%20golden%20lighting%2C%20luxurious%20evening%20gown%2C%20red%20carpet%20aesthetic%2C%20glamorous%20portrait%20photography%20with%20soft%20background%20bokeh%20and%20confident%20pose&width=800&height=500&seq=article-award&orientation=landscape',
    date: '2026-04-10',
    readTime: '4分钟',
    tags: ['金鹰奖', '提名', '春风十里', '奖项'],
  },
  {
    slug: 'meng-ruoyu-fan-meeting-2026',
    title: '孟若羽2026粉丝见面会官宣：五座城市，与你相约',
    category: 'news',
    categoryName: '最新动态',
    excerpt: '孟若羽正式宣布2026年全国粉丝见面会计划，将在北京、上海、广州、成都、武汉五座城市举办，与粉丝近距离互动。',
    content: `<p>令粉丝们翘首以盼的消息终于来了！孟若羽今日通过个人社交平台正式宣布，将于2026年夏季举办全国巡回粉丝见面会，覆盖五座城市。</p>
<h2>五城巡演，诚意满满</h2>
<p>根据官方公布的信息，本次粉丝见面会将在以下城市举办：</p>
<ul>
<li>北京：6月15日 — 国家会议中心</li>
<li>上海：6月22日 — 梅赛德斯奔驰文化中心</li>
<li>广州：7月6日 — 广州体育馆</li>
<li>成都：7月13日 — 四川省体育馆</li>
<li>武汉：7月20日 — 武汉体育中心</li>
</ul>
<p>每场见面会将包括互动游戏、才艺展示、问答环节等多个精彩环节，让粉丝能够近距离感受孟若羽的魅力。</p>
<h2>特别福利：限量签名照</h2>
<p>据悉，每场见面会的前500名购票粉丝将获得孟若羽亲笔签名照一张，此外现场还将抽取幸运粉丝上台与孟若羽合影互动。</p>
<p>"这一年多来，是粉丝们的支持让我走到了今天。这次见面会是我回馈大家的一个方式，希望能在现场见到每一位支持我的朋友，"孟若羽在公告中写道。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20actress%20waving%20to%20fans%20at%20live%20concert%20event%2C%20warm%20spotlight%20and%20stage%20atmosphere%2C%20cheerful%20smile%2C%20large%20venue%20with%20colorful%20stage%20lights%2C%20energetic%20performance%20photography&width=800&height=500&seq=article-fanmeeting&orientation=landscape',
    date: '2026-05-01',
    readTime: '5分钟',
    tags: ['粉丝见面会', '巡演', '五城', '互动'],
  },
  {
    slug: 'meng-ruoyu-acting-journey',
    title: '从舞台到银幕：孟若羽的演艺之路全记录',
    category: 'acting-career',
    categoryName: '演艺经历',
    excerpt: '从中央戏剧学院毕业到成为当红实力派演员，孟若羽用汗水与天赋书写了一段令人瞩目的演艺之路。本文将带你完整回顾她的成长历程。',
    content: `<p>孟若羽的演艺之路，是一条从学院到舞台、从荧屏到银幕的不断进阶之路。她用自己的努力和天赋，向所有人证明了真正的演员是如何炼成的。</p>
<h2>学院时代：扎根基功</h2>
<p>孟若羽毕业于中央戏剧学院表演系，在校期间她是最刻苦的学生之一。每天清晨六点起床练声，晚上十点才离开排练厅，这样的作息她坚持了整整四年。她的毕业大戏《雷雨》中饰演的繁漪一角，至今仍被老师作为教学范例使用。</p>
<p>"大学四年最大的收获不是学到了多少表演技巧，而是培养了对表演的敬畏之心。这个行业需要天赋，但更需要踏踏实实的态度。"</p>
<h2>出道初期：小角色中积累经验</h2>
<p>毕业后，孟若羽并没有立刻获得主角的机会。她在多部剧集中出演配角，有时只有短短几场戏。但即便是最小的角色，她也会认真研读整个剧本，理解角色在全剧中的位置和意义。</p>
<p>"那些年虽然辛苦，但回头看，每一个小角色都是我成长路上不可或缺的一步。"</p>
<h2>突破：《春风十里》改变一切</h2>
<p>2025年，《春风十里》让孟若羽走进了大众视野，她饰演的"林小满"成为无数观众心中的经典形象。这个角色不仅让她获得了金鹰奖最佳女主角提名，更为她打开了更广阔的演艺大门。</p>
<h2>多元化发展</h2>
<p>如今的孟若羽，已经不满足于单一类型的角色。从古装剧到现代剧，从电视剧到电影再到舞台剧，她不断挑战不同类型的表演形式，展现出一位成熟演员的多面性。</p>
<p>"表演是一件永无止境的事情。每一个新角色都是一次重新出发。"</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20actress%20in%20theater%20rehearsal%20room%2C%20warm%20natural%20light%20streaming%20through%20windows%2C%20serious%20focused%20expression%2C%20casual%20clothing%2C%20artistic%20documentary%20photography%20style%20with%20wooden%20floor%20and%20mirrors&width=800&height=500&seq=article-journey&orientation=landscape',
    date: '2026-03-18',
    readTime: '10分钟',
    tags: ['演艺经历', '成长故事', '中央戏剧学院', '春风十里'],
  },
  {
    slug: 'meng-ruoyu-photoshoot-behind-scenes',
    title: '独家幕后：孟若羽最新时尚大片拍摄花絮',
    category: 'gallery',
    categoryName: '写真图集',
    excerpt: '跟随镜头走进孟若羽最新时尚杂志封面拍摄的幕后，看她是如何在镜头前展现不同风格魅力的。',
    content: `<p>近日，孟若羽为某顶级时尚杂志拍摄了最新一期封面大片。我们有幸获准进入拍摄现场，为大家带来独家的幕后花絮报道。</p>
<h2>三组造型，三种风格</h2>
<p>本次拍摄共设计了三个主题造型：</p>
<p>第一组以"东方韵味"为主题，孟若羽身着改良旗袍，搭配简约发髻，在古典与现代之间找到完美平衡。摄影师评价说："她的眼神里有故事，这是很多模特都做不到的。"</p>
<p>第二组造型偏向摩登都市风，廓形西装搭配利落短发造型（假发），展现了孟若羽干练帅气的一面。这一组照片拍摄速度最快，因为孟若羽几乎不需要太多引导就能给出摄影师想要的感觉。</p>
<p>第三组则是浪漫柔美风格，粉色纱裙搭配自然卷发，在花园场景中营造出梦幻般的氛围。这组照片花费时间最长，需要精确的光线控制和情绪引导。</p>
<h2>专业态度令人钦佩</h2>
<p>从早上八点到晚上六点，整整十个小时的拍摄过程中，孟若羽始终保持着饱满的精神状态。即便在换装间隙，她也会主动和摄影师讨论构图和光线，展现出对作品的极高要求。</p>
<p>"若羽是我合作过最专业的艺人之一，"摄影师在拍摄结束后评价道，"她很清楚自己想要什么，也愿意为了一个完美的镜头反复尝试。"</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20actress%20fashion%20photoshoot%20behind%20the%20scenes%2C%20professional%20studio%20lighting%20setup%2C%20three%20different%20stylish%20outfits%2C%20warm%20cream%20background%2C%20high%20fashion%20editorial%20photography%20with%20soft%20diffused%20light&width=800&height=500&seq=article-photoshoot&orientation=landscape',
    date: '2026-06-08',
    readTime: '6分钟',
    tags: ['写真', '时尚', '幕后花絮', '杂志'],
  },
  {
    slug: 'meng-ruoyu-interview-growth',
    title: '孟若羽深度访谈：关于成长、梦想与未来的坦诚对话',
    category: 'interviews',
    categoryName: '访谈记录',
    excerpt: '在本次深度访谈中，孟若羽罕见地敞开心扉，聊到了成名后的心路历程、对表演的理解以及未来的职业规划。',
    content: `<p>在一个温暖的春日午后，我们与孟若羽进行了一次长达两小时的深度对话。没有闪光灯，没有镜头，只有一杯温热的茶和一段真诚的交流。</p>
<h2>关于成名：感恩与压力并存</h2>
<p><strong>记者：</strong>《春风十里》之后，你的生活发生了很大变化，适应这种变化了吗？</p>
<p><strong>孟若羽：</strong>说实话，一开始很不适应。以前我可以自由地去超市买东西、在街上散步，现在出门需要戴口罩和帽子。这是成名的代价，但我并不抱怨，因为这是我自己选择的路。我感恩所有喜欢我的人，同时也在学习如何在聚光灯下保持真实的自己。</p>
<h2>关于表演：永无止境的追求</h2>
<p><strong>记者：</strong>你觉得一个好演员最重要的品质是什么？</p>
<p><strong>孟若羽：</strong>真诚。我觉得观众是很敏锐的，你在镜头前是不是真诚，他们一眼就能看出来。技术可以通过练习获得，但真诚是装不出来的。我需要真正理解角色的情感，然后把这种理解转化为真实的表演。</p>
<h2>关于未来：不设限</h2>
<p><strong>记者：</strong>未来有什么特别想尝试的方向吗？</p>
<p><strong>孟若羽：</strong>我想尝试导演，这是我一直以来的一个梦想。不是说要取代导演，而是想从另一个角度理解影视创作。我也希望有机会参与制作一些有社会意义的作品，用自己的方式为这个世界做点什么。</p>
<h2>对于粉丝：你们是我最大的动力</h2>
<p><strong>记者：</strong>最后有什么想对粉丝说的吗？</p>
<p><strong>孟若羽：</strong>真的，非常感谢大家的支持。有时候工作很累的时候，看到粉丝的留言和鼓励，就会觉得一切都值得。我会继续努力，不辜负大家的期望。也希望每个人都能在自己的生活中闪闪发光。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20actress%20in%20cozy%20cafe%20setting%2C%20warm%20afternoon%20sunlight%2C%20intimate%20conversation%20atmosphere%2C%20natural%20makeup%20and%20casual%20outfit%2C%20documentary%20style%20portrait%20photography%20with%20wooden%20table%20and%20tea%20cup&width=800&height=500&seq=article-interview&orientation=landscape',
    date: '2026-07-12',
    readTime: '12分钟',
    tags: ['深度访谈', '成长', '梦想', '未来规划'],
  },
];